import { Injectable } from '@angular/core';
import { EventType } from '@models/ops-event/event-type';
import { createSelector, NgxsAfterBootstrap, Selector, State, StateContext } from '@ngxs/store';
import { OpsEventWebservice } from '@webservices/ops-event-api/ops-event.webservice';

export type OpsEventTypesStateModel = EventType[] | undefined;

@State<OpsEventTypesStateModel>({
  name: 'opsEventTypes',
  defaults: undefined,
})
@Injectable()
export class OpsEventTypesState implements NgxsAfterBootstrap {
  @Selector()
  static eventTypes(state: OpsEventTypesStateModel): EventType[] {
    return !!state && Array.isArray(state) ? state : [];
  }

  static eventType(id: string): any {
    return createSelector([OpsEventTypesState.eventTypes], (eventTypes: EventType[]) => {
      return eventTypes && Array.isArray(eventTypes) ? eventTypes.find((eventType) => eventType.id === id) : undefined;
    });
  }

  constructor(private readonly opsEventWebservice: OpsEventWebservice) {}

  ngxsAfterBootstrap(ctx?: StateContext<OpsEventTypesStateModel>): void {
    this.opsEventWebservice.getEventTypes().subscribe({ next: (eventTypes) => ctx.setState(eventTypes) });
  }
}
